import {
  UpdateMarketplaceGalleryV2,
  UpdateMarketplaceGalleryV2Variables
} from './__generated__/UpdateMarketplaceGalleryV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateMarketplaceGalleryV2($input: SaveMarketplaceGalleryInputV2!) {
    updateMarketplaceGalleryV2(input: $input) {
      ... on MarketplaceGalleryErrorV2 {
        type
        error
      }
      ... on MarketplaceGalleryV2 {
        id
        isNote
        items {
          id
          image
          description
          marketplaceListing {
            id
            title
          }
        }
      }
    }
  }
`

export const useUpdateMarketplaceGallery = () =>
  useMutation<UpdateMarketplaceGalleryV2, UpdateMarketplaceGalleryV2Variables>(MUTATION)
